import { createReducer, on } from '@ngrx/store';
import * as fbActions from '../Actions/fb.actions';
import { initialFbState } from '../State/Fb.state';

export const FbReducer = createReducer(
  initialFbState,
  on(fbActions.setTemplateOrderStatus, (state, { templateOrderStatus }) => ({
    ...state,
    templateOrderStatus
  })),
  on(fbActions.setIdBOT, (state, { idBOT }) => ({
    ...state,
    idBOT
  })),
  on(fbActions.setCollection, (state, { collection }) => ({
    ...state,
    collection
  }))
);
